import { v4 as uuid } from 'uuid'

import { Guest } from '@/entities/conference-participant'

import { Contact } from '@/shared/types/api'
import { fromPServedUser } from '@/shared/utils/uri'


export const unknownContact = (internalNumber: string, name: string): Contact => ({
  id: uuid(),
  internalNumber,
  name,
  groupIds: [],
  organization: '',
  imLogin: '', // Для внешнего контакта imLogin = ""
  position: '',
  mobilePhone: '',
  terminalLogin: '',
  terminalPassword: '',
  email: '',
  isFavorite: false,
})

export const contactFromGuest = (guest: Guest): Contact => ({
  id: uuid(),
  internalNumber: fromPServedUser(guest.pServed),
  name: guest.name,
  groupIds: [],
  organization: '',
  imLogin: guest.pServed,
  position: '',
  mobilePhone: '',
  terminalLogin: '',
  terminalPassword: '',
  email: '',
  isFavorite: false,
  type: 'guest',
})

export const imLoginToNumber = (sipNumber: string): string => {
  const colonIndex = sipNumber.indexOf(':')
  const atIndex = sipNumber.indexOf('@')
  if (colonIndex > -1 && atIndex > -1) {
    return sipNumber.slice(colonIndex + 1, atIndex)
  }
  return sipNumber
}
